import React, { useCallback, useState } from 'react'
import { Form } from 'react-bootstrap'
import { PROGRAM_STATUSES } from 'utils/constants'
import { pick } from 'lodash'
import { Container, ConfirmButton, Content, Trash } from './style'
import { CustomLinks } from 'components'

const { NOT_ACTIVE, NO_LONGER_AVAILABLE } = PROGRAM_STATUSES

const DeleteRecord = ({ onHide, statuses, program, translate, onSubmit }) => {
  const [status, setStatus] = useState(NOT_ACTIVE)

  const handleClick = () => {
    const statusId = statuses.find(({ name }) => name === status)?.id

    //Serialize
    const updateProgram = {
      ...pick(program, [
        'id',
        'orgId',
        'applicationType',
        'notes',
        'statusId',
        'flag',
        'coreDataStepComplete',
        'descriptiveElementsStepComplete',
        'eligibilityCodingStepComplete',
        'recheck'
      ]),
      program: program.json,
      statusId,
      visibility: 'Hide from Go Apply',
    }

    onSubmit({ program: updateProgram})
  }

  const radios = [NOT_ACTIVE, NO_LONGER_AVAILABLE]

  const onChange = useCallback((e) => setStatus(e.target.value), [setStatus])

  const subtitle = (
    <div className="px-3 small-font font-weight-lighter mt-1">
      <CustomLinks location="REMOVE.INFORMATION" />
    </div>
  )

  return (
    <div>
      <Container
        show
        onHide={onHide}
        title={translate('remove_this_record')}
        size="lg"
        variant="danger"
        subtitle={subtitle}
        actionButton={
          <ConfirmButton primary="false" className="mr-2" onClick={handleClick}>
            {translate('remove_detail_submit')}
          </ConfirmButton>
        }
      >
        <Content>
          <h5 className="font-weight-bold">
            {`${translate('remove_this_record')}?`} <Trash />
          </h5>
          <div className="font-weight-bold h6">{translate('remove_overview_title')}</div>
          <div className="font-weight-light">
            {translate('remove_overview_desc')}
          </div>
          <div className="font-weight-bold h6 mt-4">{translate('remove_detail_title')}</div>
          <div className="font-weight-light">
            {translate('remove_detail_desc')}
          </div>

          {radios.map((radio) => (
            <div className="mt-3 mb-1" key={radio}>
              <Form.Check
                type="radio"
                name="option"
                id="option"
                value={radio}
                checked={status === radio}
                label={translate(`remove_${radio.toLocaleLowerCase()}`)}
                onChange={onChange}
              />
            </div>
          ))}
        </Content>
      </Container>
    </div>
  )
}

export default React.memo(DeleteRecord)
